import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const ExperienceYogaContext = React.createContext();

export const useExperienceYogaContext = () => useContext(ExperienceYogaContext);

export function ExperienceYogaProvider({ children }) {
  const [recommendedExperiences, setRecommendedExperiences] = useState([]);
  const [recommendedHeading, setRecommendedHeading] = useState({});
  const [infoContent, setInfoContent] = useState({});
  const [suggestedQuestions, setSuggestedQuestions] = useState({});
  const [iframeData, setIframeData] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/12d480b9-bacb-44a0-88f2-ae604daaf219')
      .then(setRecommendedExperiences);
    fetchData
      .get('https://run.mocky.io/v3/ddf670d8-e7aa-4224-a0a1-0012c54d8d0c')
      .then(setRecommendedHeading);
    fetchData
      .get('https://run.mocky.io/v3/b5830c0d-3b10-4311-8cb4-4a5124f9d852')
      .then(setSuggestedQuestions);
    fetchData
      .get('https://run.mocky.io/v3/76993a63-9776-4aad-b0d9-2d2f4ed5f6f8')
      .then(setInfoContent);
    fetchData
      .get('https://run.mocky.io/v3/3cb963df-bec4-40d3-808c-ec935f64007b')
      .then(setIframeData);
  }, []);

  const value = useMemo(
    () => ({
      recommendedExperiences,
      recommendedHeading,
      infoContent,
      suggestedQuestions,
      iframeData,
    }),
    [recommendedExperiences, recommendedHeading, infoContent, suggestedQuestions, iframeData]
  );

  return <ExperienceYogaContext.Provider value={value}>{children}</ExperienceYogaContext.Provider>;
}
